import React from 'react';
import styles from './floatingItems.module.scss';

export const MiniMap = () => <div className={styles.miniMap} />;
